import { capitalize } from "@/helpers/string.helpers"
import {
  BASE_IMAGE_NAME_KEY,
  PACKAGE_NAME_KEY,
  TYPE_FILTER_KEY
} from "../../QuickWinsDrawer.constants"

import type { TFunction } from "@/hooks/useTranslation"
import type { Filters } from "@/organisms/SmartSearch/types/options.types"

export const getTypeFilterOptions = (t: TFunction) => [
  {
    label: t("quickWins.filter.packageUpdate"),
    value: "PACKAGE_UPDATE"
  },
  {
    label: t("quickWins.filter.baseImageUpdate"),
    value: "BASE_IMAGE_UPDATE"
  }
]

export const getQuickWinsFilters = (t: TFunction): Filters =>
  [
    {
      key: TYPE_FILTER_KEY,
      label: t("filters.quickWinsType"),
      displayLabel: capitalize(t("filters.quickWinsType")),
      type: "multiple",
      helper: [
        {
          label: t("filters.helpers.multipleValues", {
            label: t("filters.quickWinsType")
          }),
          description: t("filters.helpers.equals")
        }
      ],
      options: getTypeFilterOptions(t)
    },
    {
      key: PACKAGE_NAME_KEY,
      label: t("quickWins.filter.directPackageName"),
      displayLabel: capitalize(t("quickWins.filter.directPackageName")),
      type: "input",
      helper: [
        {
          label: `${capitalize(t("quickWins.filter.directPackageName"))}:value1,value2`,
          description: t("quickWins.filter.helpers.directPackageName")
        }
      ]
    },
    {
      key: BASE_IMAGE_NAME_KEY,
      label: t("quickWins.filter.baseImageNameLabel"),
      displayLabel: capitalize(t("quickWins.filter.baseImageNameLabel")),
      type: "input",
      helper: [
        {
          label: `${capitalize(t("quickWins.filter.baseImageNameLabel"))}:value1,value2`,
          description: t("quickWins.filter.helpers.baseImageName")
        }
      ]
    }
  ] as Filters
